// Ids match the seed in prisma/migrations/20260729190000_firestore_migration_seeds/migration.sql.
export var PricingRuleApplyUomMode;
(function (PricingRuleApplyUomMode) {
    PricingRuleApplyUomMode[PricingRuleApplyUomMode["ALL_UNITS"] = 1] = "ALL_UNITS";
    PricingRuleApplyUomMode[PricingRuleApplyUomMode["COMPLETE_UOM_ONLY"] = 2] = "COMPLETE_UOM_ONLY";
})(PricingRuleApplyUomMode || (PricingRuleApplyUomMode = {}));
//# sourceMappingURL=pricing-rule-apply-uom-mode.js.map